module.exports = __webpack_public_path__ + "img/03.abe8a65d.webp";